import React from 'react';
import { FaLinkedin, FaTwitter, FaGithub } from 'react-icons/fa';

export default function Footer() {
  const iconStyle = {
    transition: 'color 0.3s',
    cursor: 'pointer',
  };

  return (
    <footer style={{ background: '#0a0f29', color: '#fff', padding: '12px 20px', fontSize: '14px' }}>
      <div
        className="container"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
        }}
      >
        {/* Left */}
        <div style={{ flex: '1 1 120px', textAlign: 'left' }}>
          &gt;∞ Greater Than Infinity
        </div>

        {/* Middle */}
        <div
          style={{
            flex: '1 1 150px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
          }}
        >
          <a
            href="mailto:info@longrangesecurity.co.ke"
            style={{ color: '#fff', textDecoration: 'underline', transition: 'color 0.3s' }}
            onMouseEnter={e => (e.currentTarget.style.color = '#ff6600')}
            onMouseLeave={e => (e.currentTarget.style.color = '#fff')}
          >
            info@longrangesecurity.co.ke
          </a>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noreferrer"
              style={iconStyle}
              onMouseEnter={e => (e.currentTarget.firstChild.style.color = '#0a66c2')}
              onMouseLeave={e => (e.currentTarget.firstChild.style.color = '#fff')}
            >
              <FaLinkedin size={16} color="#fff" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noreferrer"
              style={iconStyle}
              onMouseEnter={e => (e.currentTarget.firstChild.style.color = '#1da1f2')}
              onMouseLeave={e => (e.currentTarget.firstChild.style.color = '#fff')}
            >
              <FaTwitter size={16} color="#fff" />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noreferrer"
              style={iconStyle}
              onMouseEnter={e => (e.currentTarget.firstChild.style.color = '#ff6600')}
              onMouseLeave={e => (e.currentTarget.firstChild.style.color = '#fff')}
            >
              <FaGithub size={16} color="#fff" />
            </a>
          </div>
        </div>

        {/* Right */}
        <div style={{ flex: '1 1 120px', textAlign: 'right' }}>
          © {new Date().getFullYear()} All rights reserved
        </div>
      </div>
    </footer>
  );
}
